export default "/images/KShow.webp?d70b40a31cdf755157dacb5760df027b";